<template>
  <div class="d-flex justify-content-center submission-container p-2">
    <div class="btn btn-sm btn-dark m-1" :class="isQueryDirty ? 'is-dirty':''" @click="submitSearch">SUBMIT</div>
    <div class="btn btn-sm btn-dark m-1" @click="resetQuery">RESET</div>
  </div>
</template>

<script>
import MedicalAlleyStartsMixin from './MedicalAlleyStartsMixin'
export default {
  name: '',
  mixins: [MedicalAlleyStartsMixin],
  methods: {
    submitSearch () {
      this.$emit('queryChanged')
    }
  }
}
</script>

<style scoped>
.submission-container {
  background: #FFFFFF;
  border-top: 1px solid #EEEEEE;
}
.is-dirty {
  background: #be1e2d;
}
</style>



// WEBPACK FOOTER //
// src/components/medicalAlleyStarts/SearchSubmission.vue